<template lang="pug">
	.ai-music--side-form.flex-col.space(ref="form", :class="{ active: visible && !minimized }", :style="{ '--heightDelta': waveformVisible ? '140px' : '0px', '--scrollDelta': $scopedSlots['actions'] ? '90px' : '20px' }")
		.flex-col.space-medium(v-if="visible")
			DxScrollView.form-scroll
				.content
					slot
			.bottom-panel.flex-row.space.align-center.justify-end
				slot(name="actions")
		.minimizer.flex-row.align-center.center.clickable.hoverable(v-if="visible", @click="minimized = !minimized")
			fas(:icon="minimized ? 'chevron-left' : 'chevron-right'")
</template>

<script>
import Detail from './Detail.vue';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import Popup from 'app-core/Popup.vue';
import Loader from 'app-core/Loader.vue';
import DxSlider from 'devextreme-vue/slider';
import DxScrollView from 'devextreme-vue/scroll-view';

export default {
	translationCategory: 'aiMusic.SideForm',
	components: { 
		DxButton, Popup, Detail, DxTextBox, Loader, DxSlider, DxScrollView
	},
	props: ['waveformVisible', 'visible'],
	data() {
		return {
			minimized: false
		};
	},
	computed: {
		
	},
	watch: {
		
	},
	mounted() {
		if (__DEBUG__)
			window.aiMusicSideForm = this;

		this.$form = this.$refs.form;
		document.body.appendChild(this.$form);
	},
	destroyed() {
		document.body.removeChild(this.$form);
	},
	methods: {
		
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.ai-music--side-form {
		position: fixed;
		top: 0px;
		right: 0px;
		height: calc(100% - var(--heightDelta));
		width: 70vw;
		max-width: 680px;
		background: #363640;
		z-index: 1501;
		transform: translateX(100%);
		transition: 0.3s;
		color: #f1f1f1;
		padding: 20px;
		border-left: 4px solid #2a2a33;
		border-bottom: 1px solid #2a2a33;
		border-top: 1px solid #2a2a33;

		input, textarea {
			color: #f1f1f1;
		}

		&.active {
			transform: translateX(0%);
		}

		.form-scroll {
			height: calc(100vh - var(--heightDelta) - var(--scrollDelta));
			min-height: 200px;
		}

		.ai-music-button {
			background: #42424d;
			color: #e1e1e1;
			border-radius: 4px;
			height: 36px;
			width: 34px;
		}

		.minimizer {
			position: absolute;
			left: -32px;
			top: 10px;
			width: 28px;
			height: 34px;
			background: #2a2a33;
			border-radius: 4px 0px 0px 4px;
		}

		.keywords-list {
			background: #34343d !important;
		}
	}
</style>
